import axios from "axios";
import { createAsyncThunk } from '@reduxjs/toolkit';

const AUTH_BASE_URL = process.env.REACT_APP_PUBLIC_AUTH_BASE_URL;

export const signInSubmit = createAsyncThunk(
  'auth/signInSubmit',
  async (signInFormData, { rejectWithValue }) => {
    try {
      const config = {
        headers: {
          'Content-Type': 'application/json',
        },
        withCredentials: true,
      };

      const body = JSON.stringify({
        email: signInFormData.email,
        password: signInFormData.password,
      });

      const response = await axios.post(`${AUTH_BASE_URL}/dashboard-signin`, body, config);
      return response.data;
    } catch (err) {
      if (err.message === 'Network Error') {
        return rejectWithValue({
          message: 'Network Error',
          status: err.code,
          statusText: err.code,
        });
      } else {
        return rejectWithValue(err.response?.data);
      }
    }
  }
);

export const getUser = createAsyncThunk(
  'auth/getUser',
  async (_, { rejectWithValue }) => {
    try {
      const config = {
        headers: {
          'Content-Type': 'application/json',
        },
        withCredentials: true,
      };

      const response = await axios.get(`${AUTH_BASE_URL}/get-user`, config);

      if (response.status === 200) {
        return response.data;
      } else {
        return rejectWithValue(response.data);
      }
    } catch (err) {
      if (err.message === 'Network Error') {
        return rejectWithValue({
          message: 'Network Error',
          status: err.code,
          statusText: err.code,
        });
      } else {
        return rejectWithValue(err.response?.data || { message: 'An error occurred' });
      }
    }
  }
);

export const signOutSubmit = createAsyncThunk(
  "auth/signOut",
  async (_, { rejectWithValue }) => {
    try {
      const config = {
        headers: {
          "Content-Type": "application/json",
        },
        withCredentials: true,
      };

      const response = await axios.get(`${AUTH_BASE_URL}/dashboard-logout`, config);

      if (response.data.success === true) {
        return response.data;
      } else {
        return rejectWithValue(response.data);
      }
    } catch (err) {
      if (err.message === "Network Error") {
        return rejectWithValue({
          message: "Network Error",
          status: err.code,
          statusText: err.code,
        });
      } else if (err.response && err.response.data) {
        return rejectWithValue(err.response.data);
      } else {
        return rejectWithValue({
          message: "An unexpected error occurred",
        });
      }
    }
  }
);

export const editAdminProfileImage = createAsyncThunk(
  'profile/editAdminProfileImage',
  async ({ file }, { rejectWithValue }) => {
    try {
      const config = {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
        withCredentials: true,
      };

      const formData = new FormData();
      formData.append('image', file);

      const response = await axios.put(
        `${AUTH_BASE_URL}/admin/update-user-dp`,
        formData,
        config
      );

      if (response.data.success === true) {
        return response.data;
      } else {
        return rejectWithValue(response.data);
      }
    } catch (err) {
      if (err.message === 'Network Error') {
        return rejectWithValue({
          message: 'Network Error',
          status: err.code,
          statusText: err.code,
        });
      } else {
        return rejectWithValue({
          message: err.response?.data?.message || 'Something went wrong',
          status: err.response?.status || 500,
          success: false,
        });
      }
    }
  }
);

export const adminChangePassword = createAsyncThunk(
  'auth/adminChangePassword',
  async (passwordFormData, { rejectWithValue }) => {
    try {
      const config = {
        headers: {
          'Content-Type': 'application/json',
        },
        withCredentials: true,
      };

      const body = JSON.stringify(passwordFormData);

      const response = await axios.put(`${AUTH_BASE_URL}/admin/create-new-password`, body, config);
      if (response.data.success) {
        return response.data;
      } else {
        return rejectWithValue(response.data);
      }
    } catch (err) {
      if (err.message === 'Network Error') {
        return rejectWithValue({
          message: 'Network Error',
          status: err.code,
          statusText: err.code,
        });
      } else {
        return rejectWithValue(err.response?.data || { message: 'An error occurred' });
      }
    }
  }
);
